import { Button } from "primereact/button";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import localeText from "../../../../locale";
import LanguageSelectionButton from "../../../../components/LanguageSelectionButton/LanguageSelectionButton";

const LandingDropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative w-64" style={{ height: "100%" }}>
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className="border-none border-noround outline-none p-button-no-outline border-round-md"
        style={{
          backgroundColor: isOpen ? "rgba(255,255,255,0.15)" : "#3E8B5C",
          height: "100%",
          padding: "18px",
        }}
      >
        <i style={{ fontSize: "24px" }} className={isOpen ? "pi pi-times" : "pi pi-bars"}></i>
      </Button>

      {isOpen && (
        <div
          style={{
            backgroundColor: "#3E8B5C",
            width: "100vw",
            borderTop: "1px solid rgba(255,255,255,0.15)",
          }}
          className="landing-dropdown-panel gap-4 flex flex-column p-4"
        >
          <Link
            className="font-semibold text-white hover:underline p-0 focus:shadow-none w-full text-left justify-content-start"
            to="/#negocio"
            onClick={() => props.scrollToSection("negocio")}
          >
            {localeText("benefits")}
          </Link>
          <Link
            className="font-semibold text-white hover:underline p-0 focus:shadow-none w-full text-left justify-content-start"
            to="/#resources"
            onClick={() => props.scrollToSection("resources")}
          >
            {localeText("resources")}
          </Link>
          <Link
            className="font-semibold text-white hover:underline p-0 focus:shadow-none w-full text-left justify-content-start"
            to="/#plans"
            onClick={() => props.scrollToSection("plans")}
          >
            {localeText("plans")}
          </Link>
          <a
            href="https://extraconomy.blog/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-white hover:underline"
          >
            {localeText("blog")}
          </a>
          <Link
            to="/shop"
            className="font-bold text-white no-underline flex align-items-center justify-content-center gap-2 border-round-lg w-full"
            style={{ backgroundColor: "#2A2560", padding: "14px" }}
          >
            <i className="pi pi-shopping-cart"></i>
            {localeText("toTheStore")}
          </Link>
          <hr className="p-0 m-0 w-full" style={{ borderTop: "solid 1px rgba(255,255,255,0.15)" }} />
          <LanguageSelectionButton storePage={false} />
        </div>
      )}
    </div>
  );
};

export default LandingDropdown;
